<template>
<div>
  <div v-if="spinner" class="d-flex justify-content-center">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
 <div v-else>

<div class="modal-content border border-success">
<div  style="background-color:#9acd32;color:black" class="modal-header border border-success text-nowrap ">
  <h4 class="modal-title ">
    <i style="color:blue" class="fas fa-cash-register mr-3" aria-hidden="true"></i>     
    <strong>STAMPA NOTA DI CREDITO</strong>
  </h4>  
</div>

<div class="modal-body">
  
  <form >  
  <p class="text-center mt-4" style="color:red"><strong>{{notFound}}</strong></p>  
  <div class="form-row">
    <div class="col">
      <strong><label>NUMERO SCONTRINO</label></strong>
      <input v-focus type="text" @input="msg=''" ref="fiscalReceipNumber"  maxlength="4" v-on:keydown="keyHandler($event,'Num')" class="form-control" placeholder="0000" v-model="creditNote.fiscalReceiptNumber">
     
    </div>
    <div class="col">
      <strong><label>NUMERO RAPPORTO</label></strong>     
      <input type="text" ref="zRepNumber"  @input="msg=''"  v-on:keydown="keyHandler($event,'Num')" maxlength="4"  class="form-control" placeholder="0000" v-model="creditNote.zRepNumber">
     
    </div>
    <div class="col">
      <strong><label>DATA SCONTRINO</label></strong>
      <input type="text" ref="fiscalReceiptDate" @input="msg=''"  v-on:keydown="keyHandler($event,'Num')"  maxlength="8"  class="form-control" placeholder="GGMMAAAA" v-model="creditNote.fiscalReceiptDate">
       
    </div>

  </div>

  <button @click="$emit('close')" type="button" class="btn btn-secondary float-left mt-4">
      <i class="fas fa-reply mr-2" aria-hidden="true"></i>
        ANNULLA
  </button>

  <button  @click="postXML()" :disabled="bt_spinner==true" type="button" class="btn btn-primary float-right mt-4">
          <i class="fas fa-print mr-2" aria-hidden="true"></i>   
            STAMPA
          <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
  </button>  

</form>
<p class="text-center mt-4" style="color:red"><strong>{{msg}}</strong></p>

</div>
</div>
</div> 

</div>

</template>

<script>
import axios              from 'axios'
import api                from '@/api'
import keyHandler         from '@/components/mixins/keyHandler'
import getSaleData        from '@/components/rt/mixins/getSaleData'
import updateFPStatus     from '@/components/rt/mixins/UpdateFiscalPrintStatus'
export default {
   mixins: [keyHandler,getSaleData,updateFPStatus],
   props:['data'],

  data() {
    return {
      
      creditNote : {
        fiscalReceiptNumber : ''
      },
      msg        : '',
      spinner    : true,
      notFound   : '',
      items      : [],
      payments   : [],
      url        : '',
      bt_spinner : false
            
    };
  },
    directives: {
    focus: {
      // directive definition
      inserted: function(el) {
                
        el.focus();
      }
    }
  },

  
 async created () 
      {
        console.log('CREDIT NOTE',this.data) 
        
        this.getFiscalReceiptData()
        const data     = await this.getSaleData(this.data.saleId)
        this.items     = data[0]
        this.payments  = data[1]

        
        

      },  
  methods: 
  {
  
    getXML()    
          { 

            let total = 0
            this.items.forEach(item => {              
              total += item.price
            })
            
            //const total                = Math.abs(this.payments[0].amount)                      
                        
            const zRepNumber           = this.creditNote.zRepNumber
            const fiscalReceiptNumber  = this.creditNote.fiscalReceiptNumber
            const fiscalReceiptDate    = this.creditNote.fiscalReceiptDate
            //const serialNumber         = this.data.serialNumber
            const serialNumber         = this.creditNote.serialNumber
                        
            let xml =  '<printerFiscalReceipt>' 
            xml += '<printRecMessage operator="1" messageType="4" message="REFUND ' + zRepNumber + ' '  + fiscalReceiptNumber + ' ' + fiscalReceiptDate + ' ' + serialNumber  + '"' + '/>'  
            xml += '<beginFiscalReceipt operator="1" />'
                     
            this.items.forEach(item => {              
              xml += '<printRecRefund operator="1" description="' + item.barcode +  ' ' + item.category +  '" quantity="1" unitPrice="' + item.price  + '"  justification="1" />'                                    
            })
           
            xml += '<printRecTotal operator="1" description="PAGAMENTO CONTANTE " payment="' + total + '" paymentType="0" index="1" justification = "2" />'            
            xml += '<endFiscalReceipt  operator="1"/></printerFiscalReceipt>'

            console.log('EPSON FISCAL REFUND',xml)  

            return xml
            

          },  
   
          getSOAP(xml)
          {
            const soap = '<?xml version="1.0" encoding="utf-8"?>\n' +
            '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">\n' +
              '<s:Body>\n' + xml +
            '</s:Body>\n' +
            '</s:Envelope>\n'
            return soap
          },

  async getFiscalReceiptData()
    {
      
      const sp         = {'sp'     : 'spSaleFiscalReceipt'}
      const data       = {'saleId' : this.data.receiptSaleId }
      const json       = Object.assign(data, sp)

      await api.post(json).then(res => {

        if(res.status == 200)
        {
          
          if(res.data.recordsets[0].length > 0)
          {
            this.creditNote.fiscalReceiptNumber  = res.data.recordsets[0][0].fiscalReceiptNumber
            this.creditNote.zRepNumber           = res.data.recordsets[0][0].zRepNumber
            this.creditNote.fiscalReceiptDate    = res.data.recordsets[0][0].fiscalReceiptDate
            this.creditNote.serialNumber         = res.data.recordsets[0][0].serialNumber
          }
          else
          {
            //this.notFound = 'DATI SCONTRINO DI VENDITA NON TROVATI.'
          }
        }
        else if(res.status==500)
          {
            console.log(res.data)
            
          }
          else
          {
            console.log(res)
            
          } 

        })
        .catch(err => 
      {
      
        console.log(err.message)
      }).finally(() => {
        this.spinner = false
       
      });
    },

    
    postXML()
    {
      if(this.checkData() == false)
      {
        return
      }
      this.msg  = ''
      this.bt_spinner = true
      const soap = this.getSOAP(this.getXML())  
      axios({
               
               url    : this.data.url + '/cgi-bin/fpmate.cgi',
               method : 'post',
               data   : soap

             }).then(res => {
              this.bt_spinner = false
              this.updateFiscalPrintStatus(this.data.saleId)
              console.log('RT Response',res)
              this.$emit('close')
               
             }).catch(err => {
              
                this.msg = err
                

                this.bt_spinner = false                            
               console.log('Errore RT',err)  
             })
       
    },       
    checkData()
    {
        

      this.msg = ''
     
      if(!this.creditNote.fiscalReceiptNumber)
      {
        
        this.msg = 'NUMERO SCONTRINO NON VALIDO.'
        this.$nextTick(function () {
        
            this.$refs['fiscalReceipNumber'].focus()
        
        })
        
        return false
      }
      else if(this.creditNote.fiscalReceiptNumber.length != 4 )
      {
        this.msg = 'NUMERO SCONTRINO NON VALIDO.'
         this.$nextTick(function () {
        
            this.$refs['fiscalReceiptNumber'].focus()
        
        })
        return false  
        
      }
      else if(parseInt(this.creditNote.fiscalReceiptNumber)==0)
      {
        this.msg = 'NUMERO SCONTRINO NON VALIDO.'
         this.$nextTick(function () {
        
            this.$refs['fiscalReceipNumber'].focus()
        
        })
        return false
        
      }

      else if(!this.creditNote.zRepNumber)
      {
        this.msg = 'NUMERO RAPPORTO NON VALIDO.'
         this.$nextTick(function () {
        
            this.$refs['zRepNumber'].focus()
        
        })
        return false
        
      }
      else if(this.creditNote.zRepNumber.length != 4)
      {
        this.msg = 'NUMERO RAPPORTO NON VALIDO.'
        this.$nextTick(function () {
        
            this.$refs['zRepNumber'].focus()
        
        })
        return false
        
      }
      else if(parseInt(this.creditNote.zRepNumber)  == 0)
      {
        this.msg = 'NUMERO RAPPORTO NON VALIDO.'
        this.$nextTick(function () {
        
            this.$refs['zRepNumber'].focus()
        
        })
        return false
        
      }
      else if(!this.creditNote.fiscalReceiptDate)
      {
        this.msg = 'DATA SCONTRINO NON VALIDA.'
        this.$nextTick(function () {
        
            this.$refs['fiscalReceiptDate'].focus()
        
        })
        return false
        
      }
      else if (this.creditNote.fiscalReceiptDate.length != 8)
      {
        this.msg = 'DATA SCONTRINO NON VALIDA.'
        this.$nextTick(function () {
        
            this.$refs['fiscalReceiptDate'].focus()
        
        })
        return false
      }  
        

      return true
     
    },
   

    
}
}

</script>
<style scoped>

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;  
}
small {
  font-family  : 'Roboto Condensed';
  font-size    : 10px;
}

::placeholder {
  color: rgb(106, 17, 223);
  opacity: 1; /* Firefox */
}



input {
  font-weight: bold;
}


</style>


